const _ = ["#B05420"], o = [..._, "#E4214E"], t = [..._, "#DD1342", "#58027E"], E = [...o, "#E4F718", "#E2824B"];
export {
  _ as POI_5_TA1,
  o as POI_5_TA2,
  t as POI_5_TA3,
  E as POI_5_TA4
};
//# sourceMappingURL=index.es5718.js.map
